import { useEffect, useState } from "react"
import { FaEye, FaEyeSlash, FaCheck, FaTimes } from "react-icons/fa"
import { useLogin } from "../hooks/useLogin"
import T from "../../../components/Translation"
import BlueButton from "../../../components/BlueButton"
import VisDiv from "../../components/VisDiv"
import TextField from "../../../whitaijiFrontendLibrary/components/TextField"
import { useNavigate } from 'react-router-dom'
import { useStateContext } from "../../../context/StateContext"

const Login = ({AuthContext}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const invited = urlParams.get('invited');
  const { hideTestButtons } = useStateContext()
  process.env.NODE_ENV === "development" && console.log("urlParams", invited)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  // Password validation state
  const [passwordValidation, setPasswordValidation] = useState({
    minLength: false,
    minLowercase: false,
    minUppercase: false,
    minNumbers: false,
    minSymbols: false
  })
  const [otpSent, setOtpSent] = useState(false)
  const [changePassword, setChangePassword] = useState(false)
  const [code, setCode] = useState('')  
  const {login, sendOtp, getOtp, error, isLoading} = useLogin(AuthContext)

  useEffect(() => {
    if (invited) {
      setChangePassword(true)
    }
  }, [invited])
  const ValidationItem = ({ isValid, text }) => (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '8px',
      color: isValid ? '#4CAF50' : '#f44336',
      marginBottom: '4px',
      fontSize: '14px'
    }}>
      {isValid ? <FaCheck /> : <FaTimes />}
      {text}
    </div>
  );

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);
    
    // Update validation states
    setPasswordValidation({
      minLength: pwd.length >= 8,
      minLowercase: /[a-z]/.test(pwd),
      minUppercase: /[A-Z]/.test(pwd),
      minNumbers: /[0-9]/.test(pwd),
      minSymbols: /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault()

    await login(email, password)
  }
  const sendOtpHandler = async (e) => {
    e.preventDefault()
    process.env.NODE_ENV === "development" && console.log("doi2jdoi32jd")
    //await sendOtp(email)
    const response = await sendOtp(email)
    process.env.NODE_ENV === "development" && console.log("response", response)
    if(response?.ok){
      setOtpSent(true)
    }
  }
    const navigate = useNavigate();  const sendVerificationCodeHandler = async (e) => {
    e.preventDefault()
    process.env.NODE_ENV === "development" && console.log("òkjnflkòjn", email, code)
    //await sendOtp(email)
    const response = await getOtp(email, code)
    process.env.NODE_ENV === "development" && console.log("response", response)
    if(response?.ok){
      //navigate('/change-password')
      //setOtpSent(true)
    }
  }

  return (
    <>
    <form className="login" onSubmit={handleSubmit}>
      <h3 style={{marginBottom:"30px"}}><T str={"logIn"}/></h3>
      
      <label><T str={"emailAddress"}/></label>
    
      <div style={{ position: 'relative', width: '100%' }}>
        <input 
          type="email" 
          onChange={(e) => setEmail(e.target.value)} 
          value={email} 
          style={{ width: '100%' }}
        />
      </div>

      <VisDiv rules={[!changePassword]}>
        <label>Password:</label>
        <div style={{ position: 'relative', width: '100%' }}>
          <input 
            type={showPassword ? "text" : "password"} 
            onChange={handlePasswordChange} 
            value={password} 
            style={{ width: '100%' }}
          />
          <div 
            onClick={() => setShowPassword(!showPassword)} 
            style={{ 
              position: 'absolute', 
              right: '10px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              cursor: 'pointer'
            }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </div>
        </div>
{/*         {password && (
          <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <ValidationItem isValid={passwordValidation.minLength} text="Almeno 8 caratteri" />
            <ValidationItem isValid={passwordValidation.minLowercase} text="Almeno 1 lettera minuscola" />
            <ValidationItem isValid={passwordValidation.minUppercase} text="Almeno 1 lettera maiuscola" />
            <ValidationItem isValid={passwordValidation.minNumbers} text="Almeno 1 numero" />
            <ValidationItem isValid={passwordValidation.minSymbols} text="Almeno 1 carattere speciale" />
          </div>
        )} */}
        <button disabled={isLoading || !email || !password || !Object.values(passwordValidation).every(Boolean)}><T str={"logIn"}/></button>
      </VisDiv>
      <VisDiv rules={[!invited]}>
      <p onClick={() => setChangePassword(!changePassword)} style={{marginTop:"10px", cursor:"pointer"}}><T obj={{en:"Forgot your password?", it: "Hai dimenticato la password?"}}/></p>
      <p onClick={() => setChangePassword(!changePassword)} style={{marginTop:"10px", cursor:"pointer"}}><T obj={{en:"I have been invited", it: "Ho ricevuto un invito"}}/></p>
      </VisDiv>
    </form>
      <VisDiv style={{marginTop:"-60px"}} rules={[changePassword]} className="login">
        <VisDiv rules={[!otpSent]}>
        <BlueButton margins={false} style={{marginTop:"10px"}} text={<T obj={{en:"Send Code", it: "Invia Codice"}}/>} fn={sendOtpHandler}/>
        </VisDiv>
        <VisDiv rules={[otpSent]}>
          <TextField label={<T obj={{en:"Enter Code", it: "Inserisci Codice"}}/>} type="text" onChange={(e) => setCode(e.target.value)}/>
          <BlueButton margins={false} style={{marginTop:"10px"}} text={<T obj={{en:"Verify Code", it: "Verifica Codice"}}/>} fn={sendVerificationCodeHandler}/>
        </VisDiv>
      </VisDiv>
      <VisDiv style={{marginTop:"-60px"}} rules={[error]} className={"login"}>
        <div className="error">{error}</div>
      </VisDiv>
  
     </>
  )
}

export default Login
